<div class="tem-field customtextarea" [formGroup]="group">
        <div class="tem-field-label-row">
            <label class="tem-field-label" [attr.for]="config.IDCOLUMN">{{config.COLUMNDESC}}<span class="tem-field-required" *ngIf="config.ISREQUIRED == 1"> *</span></label>
            <span class="tem-field-suffix">
                <button tabindex="-1" type="button" *ngIf="!config.COLUMNNAME.endsWith('_ORIGINAL')" nz-button nzType="text" nzSize="small" aria-label="Editar" (click)="openJSONPopUp(inp.value)">
                    <nz-icon nzType="edit"></nz-icon>
                </button>
                <button nz-button nzType="text" nzSize="small" *ngIf="toolTipText!=null" [tooltip]="toolTipText">
                    <nz-icon nzType="question-circle"></nz-icon>
                </button>
                <button *ngIf="showBuscaDados" tabindex="-1" nz-button nzType="text" nzSize="small" aria-label="Buscar do Dados" (click)="dynaServices.getDataFromTable(group, config.COLUMNNAME,entityName, null, null, 'text');editing()" nz-tooltip="Buscar do Dados">
                    <nz-icon nzType="rollback"></nz-icon>
                </button>
                <form-field-properties [information]="config" [entityDesc]="entityDesc" [entityName]="entityName" *ngIf="canConfig" [row]="row"></form-field-properties>
            </span>
        </div>
        <textarea nz-input [tabindex]="tabindex" [formControlName]="config.COLUMNNAME" [placeholder]="config.PLACEHOLDER" [id]="config.IDCOLUMN" [required]="config.ISREQUIRED == 1" #inp nzAutosize (input)="dynaServices.editingEventHandle($event);editing()"
        (blur)="bluring($event)"></textarea>
</div>
